import { Facebook, Linkedin, Instagram, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { trackEvent } from "./track";
import { useI18n } from "../../i18n";

export const Footer = () => {
  const { t } = useI18n();
  return (
    <footer className="border-t border-white/10 pt-20 pb-10" data-testid="footer-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          <div className="md:col-span-5">
            <p className="flex items-center gap-3 font-heading font-bold text-xl tracking-tight mb-5">
              <img src="/logo-cs.png" alt="Logo Consultants Succès" className="h-10 w-auto" />
              CONSULTANTS <span className="text-gold">SUCCÈS</span>
            </p>
            <p className="text-[#8A9DB1] leading-relaxed max-w-sm">{t("footer.desc")}</p>
          </div>

          <div className="md:col-span-4">
            <p className="font-heading text-sm tracking-[0.18em] uppercase text-[#8A9DB1] mb-5">{t("footer.coordinates")}</p>
            <p className="text-[#c8d3dc] leading-relaxed">
              {t("address.line1")}<br />
              {t("address.line2")}<br />
              {t("address.country")}
            </p>
            <p className="text-[#c8d3dc] mt-3">
              <a href="tel:+15813333447" className="hover:text-white transition-colors duration-300" data-testid="footer-phone-link">+1 581-333-3447</a>
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="font-heading text-sm tracking-[0.18em] uppercase text-[#8A9DB1] mb-5">{t("footer.follow")}</p>
            <div className="flex items-center gap-3" data-testid="footer-social-icons">
              <a href="https://www.facebook.com/consultantsucces" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="social-link" data-testid="social-facebook">
                <Facebook size={19} strokeWidth={1.6} />
              </a>
              <a href="https://www.linkedin.com/company/consultants-succes" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="social-link" data-testid="social-linkedin">
                <Linkedin size={19} strokeWidth={1.6} />
              </a>
              <a href="https://www.instagram.com/consultants_succes" target="_blank" rel="noopener noreferrer" aria-label="Instagram @consultants_succes" className="social-link" data-testid="social-instagram">
                <Instagram size={19} strokeWidth={1.6} />
              </a>
            </div>
            <Link
              to="/impact-social"
              className="block text-gold text-sm font-heading tracking-[0.1em] uppercase mt-8 hover:text-[#f0b45a] transition-colors duration-300"
              data-testid="footer-impact-link"
            >
              {t("nav.impact")}
            </Link>
            <a
              href="https://vytalimarketing.com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-gold text-sm font-heading tracking-[0.1em] uppercase mt-4 hover:text-[#f0b45a] transition-colors duration-300"
              onClick={() => trackEvent("click_decouvrir_vytali", { location: "footer" })}
              data-testid="footer-vytali-link"
            >
              {t("footer.vytali")} <ArrowUpRight size={14} />
            </a>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="text-[#8A9DB1] text-sm">
            © {new Date().getFullYear()} Consultants Succès Inc. {t("footer.rights")}
          </p>
          <p className="text-[#8A9DB1] text-sm">{t("footer.role")}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
